// SHARED CONSTANTS ACROSS THE PROJECT

export const SHARED_CURRENCIES = [
    { value: 'AED', label: 'AED' },
    { value: 'USD', label: 'USD' },
    { value: 'EUR', label: 'EUR' },
    { value: 'GBP', label: 'GBP' },
    { value: 'CHF', label: 'CHF' },
    { value: 'SAR', label: 'SAR' },
];

export const COUNTRY_PHONE_CODES = [
    { value: '+971', label: '🇦🇪 +971 UAE' },
    { value: '+1', label: '🇺🇸 +1 USA' },
    { value: '+44', label: '🇬🇧 +44 UK' },
    { value: '+33', label: '🇫🇷 +33 France' },
    { value: '+49', label: '🇩🇪 +49 Germany' },
    { value: '+39', label: '🇮🇹 +39 Italy' },
    { value: '+34', label: '🇪🇸 +34 Spain' },
    { value: '+966', label: '🇸🇦 +966 Saudi Arabia' },
    { value: '+974', label: '🇶🇦 +974 Qatar' },
    { value: '+965', label: '🇰🇼 +965 Kuwait' },
    { value: '+961', label: '🇱🇧 +961 Lebanon' },
    { value: '+962', label: '🇯🇴 +962 Jordan' },
    { value: '+20', label: '🇪🇬 +20 Egypt' },
    { value: '+91', label: '🇮🇳 +91 India' },
    { value: '+92', label: '🇵🇰 +92 Pakistan' },
    { value: '+86', label: '🇨🇳 +86 China' },
    { value: '+81', label: '🇯🇵 +81 Japan' },
    { value: '+82', label: '🇰🇷 +82 South Korea' },
    { value: '+65', label: '🇸🇬 +65 Singapore' },
    { value: '+60', label: '🇲🇾 +60 Malaysia' },
    { value: '+66', label: '🇹🇭 +66 Thailand' },
    { value: '+63', label: '🇵🇭 +63 Philippines' },
    { value: '+61', label: '🇦🇺 +61 Australia' },
    { value: '+64', label: '🇳🇿 +64 New Zealand' },
    { value: '+27', label: '🇿🇦 +27 South Africa' },
    { value: '+7', label: '🇷🇺 +7 Russia' },
    { value: '+9 Turkish', label: '🇹🇷 +90 Turkey' },
    { value: '+41', label: '🇨🇭 +41 Switzerland' },
    { value: '+31', label: '🇳🇱 +31 Netherlands' },
    { value: '+32', label: '🇧🇪 +32 Belgium' },
    { value: '+46', label: '🇸🇪 +46 Sweden' },
    { value: '+47', label: '🇳🇴 +47 Norway' },
    { value: '+45', label: '🇩🇰 +45 Denmark' },
    { value: '+351', label: '🇵🇹 +351 Portugal' },
    { value: '+30', label: '🇬🇷 +30 Greece' },
    { value: '+48', label: '🇵🇱 +48 Poland' },
    { value: '+55', label: '🇧🇷 +55 Brazil' },
    { value: '+52', label: '🇲🇽 +52 Mexico' },
    { value: '+54', label: '🇦🇷 +54 Argentina' },
];
